"use client";

import { cn } from "@unreserved/utils/cn";

export interface NotificationItemProps {
  title: string;
  message: string;
  date: string;
  variant: "row" | "stack";
  onClick?: () => void;
  isLast?: boolean;
  isRead?: boolean;
}

export function NotificationItem({
  title,
  message,
  date,
  variant,
  onClick,
  isLast = false,
  isRead = false,
}: NotificationItemProps) {
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={cn(
        "border-secondary-100 flex w-full gap-3 border-b px-4 py-3 text-left",
        variant === "row" && "items-center",
        variant === "stack" && "items-start",
        onClick && "hover:bg-background-50 cursor-pointer",
        isLast && "rounded-b-lg",
        !isRead && "bg-primary-100",
      )}>
      {/* <div className="relative shrink-0">
        <div
          className={cn(
            "flex size-10 items-center justify-center rounded-full",
            bg,
          )}>
          <Icon className="size-4" />
        </div>
        {unread && (
          <span className="bg-primary-600 absolute top-0 left-1 size-2 rounded-full" aria-hidden />
        )}
      </div> */}
      <div
        className={cn(
          "min-w-0 flex-1",
          variant === "row" && "flex items-start justify-between gap-3",
          variant === "stack" && "flex flex-col gap-1",
        )}>
        <span className="flex flex-col gap-1">
          <span className="relative flex items-center gap-2">
            <p className="text-typography-800 text-sm font-semibold">{title}</p>
            {!isRead && <span className="bg-primary-600 size-2 rounded-full" aria-hidden />}
          </span>
          <p className="text-typography-800 text-xs">{message}</p>
        </span>
        <span
          className={cn("text-typography-500 shrink-0 text-xs", variant === "row" && "text-right")}>
          {date}
        </span>
      </div>
    </Wrapper>
  );
}
